import BasicLayout from "components/layouts/BasicLayout";
import withAuth from 'lib/withAuth';
import { useSelector, useDispatch } from 'react-redux';
import {  useCurrentIdToken, useCurrentJWT } from 'lib/AuthUtils';
import { CognitoIdToken } from '@xeedware/cognito-jwt';
import { currentUserSelector } from "features/me/selectors";
import { IUserSlice } from "features/me/meSlice";

function Admin() {

  const idToken:CognitoIdToken = useCurrentIdToken();
  const currentUser:IUserSlice = useSelector(currentUserSelector());

  return (
      <BasicLayout>
      <div>
          <div className="row px-0 mx-0">
            <div className="col-5 d-flex align-items-center d-flex align-items-center justify-content-center">
              
              {idToken?.email && (
                <h3 className="text_welcome"> Hello, {currentUser?.firstname ?? idToken.email}.<br></br></h3>
              )}
              
            </div>
            <div className="col-7">
              <div className='bg_svg'>
                <img src='/klaudsol-cms-vector-laptop.png' className="admin-vector-image"></img>
              </div>
              
            </div>
           </div>
        </div>
      </BasicLayout>
  );
}

export default withAuth(Admin);


